// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"395c445a","509":"9db8c760","546":"27157f37","793":"b7073c9f"}[chunkId] + ".chunk.js";
};